
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watchlists/[watchlistId]",
      function () {
        return require("private-next-pages/watchlists/[watchlistId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watchlists/[watchlistId]"])
      });
    }
  